module.exports = __webpack_public_path__ + "img/obs_sea_caution.1ac10340.svg";